import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";

interface MiniSection2Props {
  data: MiniQuestionnaireData;
  updateData: (field: keyof MiniQuestionnaireData, value: string) => void;
}

const MiniSection2 = ({ data, updateData }: MiniSection2Props) => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Section II – Activité physique
      </h2>

      {/* Question 4 - Renforcement musculaire */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q4. Intégrez‑vous des exercices de renforcement musculaire (comme des squats, des pompes ou des abdos) dans votre routine hebdomadaire ?
        </Label>
        <RadioGroup
          value={data.renforcement_musculaire}
          onValueChange={(value) => updateData("renforcement_musculaire", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="au_moins_2_fois" id="renf-2fois" />
            <Label htmlFor="renf-2fois" className="cursor-pointer">Au moins 2 fois par semaine</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="moins_de_2_fois" id="renf-moins2" />
            <Label htmlFor="renf-moins2" className="cursor-pointer">Moins de 2 fois par semaine</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="jamais" id="renf-jamais" />
            <Label htmlFor="renf-jamais" className="cursor-pointer">Jamais</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default MiniSection2;
